import React from "react";
import { Route, IndexRoute } from "react-router";
import UserAccountContainer from "../components/dashboard/UserAccountContainer";
import PasswordChange from "../components/dashboard/PasswordChange";
import UserAccount from "../components/dashboard/UserAccount";
import UserAccountShow from "../components/dashboard/UserAccountShow";

export const accountRoutes = (
  <Route path="account" component={UserAccountContainer}>
    <IndexRoute component={UserAccountShow} />
    <Route path="email-change" component={UserAccount} />
    <Route path="password-change" component={PasswordChange} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes/accountRoutes.js